import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  size: 10,
  status: 'ALL' as 'ALL' | 'SAVED' | 'CANCELED',
  filter: {
    startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
    endDate: new Date(),
  },
};

const fxReceiptSlice = createSlice({
  name: 'fxReceipt',
  initialState,
  reducers: {
    setSize: (state, action) => {
      state.size = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = {
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
      };
    },
  },
});

export const { setSize, setStatus, setFilter } = fxReceiptSlice.actions;

export default fxReceiptSlice.reducer;
